import features from '../../../../assets/illustrations/features.svg'
import recording from '../../../../assets/illustrations/recording.svg'
import live from '../../../../assets/illustrations/live-chat.svg'
import discount from '../../../../assets/illustrations/discount.svg'

const benefitsData = [
  {
    key: `priority`,
    graphic: features,
    title: `Priority Access`,
    text: () => (
      <>
        Be the first to access all our features - some of them offering{' '}
        <strong>powerful interactions</strong> with{' '}
        <strong>your favorite musicians!</strong>
      </>
    ),
  },
  {
    key: `discounts`,
    graphic: discount,
    title: `Bonus discounts`,
    text: ({
      features: { broadcastClasses, discountBc, discountCourse } = {},
    } = {}) => (
      <>
        If you run out of <strong>{broadcastClasses} live classes</strong>, you
        still enjoy an additional <strong>{discountBc}% discount</strong> on all
        our <strong>live class</strong> tickets and{' '}
        <strong>{discountCourse}% discount</strong> on all our{' '}
        <strong>Group courses</strong>!
      </>
    ),
  },
  {
    key: `recordings`,
    graphic: recording,
    title: `Recordings`,
    text: () => (
      <>
        All our previous live sessions. Everything! You also get session
        recordings unlocked a lot sooner than others can even buy them.
      </>
    ),
  },
  {
    key: `live-chat`,
    graphic: live,
    title: `Live Chat`,
    text: () => (
      <>
        But for the classes you select, you'll be able to directly interact with
        all of our <strong>LivDemy</strong> artists - even face-to-face, if your
        camera's on!
      </>
    ),
  },
]

export default benefitsData
